export const CURRENCY_SYMBOLS: {[key: string]: string} = {
    KZT: '₸',
    USD: '$',
    GBP: '£',
    EUR: '€',
    CHF: 'CHF',
    CAD: 'C$',
    RUB: '₽'
};


export const AMO_CRM_TAG_IDS: {[key:string]: number} = {
    'RU': 328555,
    'KZ': 328557
}